/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import XtadiumExtendedInfo from '../../atoms/customIcons/XtadiumExtendedInfoNoImage.png';
import { TabContent } from 'react-bootstrap';
import SingleTagPreview from './singleTagPreview';
import { TagsCheckToday, TagsReplaceDateLabelsWithDate } from '../../../utils/dateUtils';

/**
 * Form Input Text is a basic HTML input field, label, error text and HelpButton.
 * It is designed to send the input value to a parent component, such as organisms Form,
 * and to shows the validation state of the field provided by the parent component.
 */
const ExtendedInfoPreview = (props) => {
  const {
    size,
    visible,
    tags,
    name,
    image,
    purchase,
    subscription,
    georestricted,
    
  } = props;
  const [topTags,setTopTags] =useState([]);
  const [mediumTags,setMediumTags]=useState([]);
  const [bottomTags,setBottomTags]=useState([]);
  const [width,setWidth]=useState(0);
  const [height,setHeight]=useState(0);
  const [scaleImages,setScaleImages]=useState(0.6);

  useEffect(() => {
    if(tags){
      let resTopTags=[];
      let resMediumTags=[];
      let resBottomTags=[];
      let found = tags.defaultTags.find( (element) => element.props && element.props.position == "middle-left");

      if (found && found.visible) {
        resMediumTags = [
          ...resMediumTags,
          <SingleTagPreview key={found.id} mode="extendedInfo" rawValue={found} />
        ];
      }
      if(purchase=="yes"){
        let found = tags.defaultTags.find((element=>element.name=="Purchase-on"));
        let b;
        if(found && found.visible){
          b=(<SingleTagPreview key={"purchaseOn"} mode="extendedInfo" rawValue={found} />);
        }
        resBottomTags=[...resBottomTags,b];
      }
      if(purchase=="no"){
        let found = tags.defaultTags.find((element=>element.name=="Purchase-off"));
        let m;
        if(found && found.visible){
          m=(<SingleTagPreview key={"purchaseOff"} mode="extendedInfo" rawValue={found} />);
        }
        resMediumTags=[...resMediumTags,m];
      }
      if(subscription=="yes"){
        let found = tags.defaultTags.find((element=>element.name=="Subscription-on"));
        let b;
        if(found){
          b=(<SingleTagPreview key={"subscriptionOn"} mode="extendedInfo" rawValue={found} />);
        }
        resBottomTags=[...resBottomTags,b];
      }
      if(subscription=="no"){
        let found = tags.defaultTags.find((element=>element.name=="Subscription-off"));
        let m;
        if(found){
          m=(<SingleTagPreview key={"subscriptionOff"} mode="extendedInfo" rawValue={found} />);
        }
        resMediumTags=[...resMediumTags,m];
      }
      if(georestricted=="yes"){
        let found = tags.defaultTags.find((element=>element.name=="Geo-restricted"));
        let t;
        if(found){
          t=(<SingleTagPreview key={"geoOn"} mode="extendedInfo" rawValue={found} />);
        }
        resTopTags=[t];
      }
          if(tags.tags){
        tags.tags.forEach((tag)=>{
          let tagPosition=tag.props.position;
          if(tag.visible){
            if(tagPosition=="top"){
              if(tag.name=="Live-date" || tag.name=="Live-today"){
                //Check if we need to draw the live today or live some day
                if(tag.name=="Live-today" && TagsCheckToday(tag.label)==true){
                  tag.label=TagsReplaceDateLabelsWithDate(tag.label);
                  let t=(<SingleTagPreview key={tag.id} mode="extendedInfo" rawValue={tag} />);
                  resTopTags.push(t);
                }else if(tag.name=="Live-date" && !TagsCheckToday(tag.label)){
                  tag.label=TagsReplaceDateLabelsWithDate(tag.label);
                  let t=(<SingleTagPreview key={tag.id} mode="extendedInfo" rawValue={tag} />);
                  resTopTags.push(t);
                }
              } else{
                let t=(<SingleTagPreview key={tag.id} mode="extendedInfo" rawValue={tag} />);
                resTopTags.push(t);
              }
            }
            if(tagPosition=="middle"){
              let m=(<SingleTagPreview key={tag.id} mode="extendedInfo" rawValue={tag} />);
              resMediumTags.push(m);
            }
            if(tagPosition=="bottom")  {
              // let b=(<div>{tag.name}</div>);
              let b=(<SingleTagPreview key={tag.id} mode="extendedInfo" rawValue={tag} />);
              resBottomTags.push(b);
            }
          }
        });
      }
      setTopTags(resTopTags);
      setMediumTags(resMediumTags);
      setBottomTags(resBottomTags);
      setWidth(664*scaleImages +"px");
      setHeight(664*scaleImages +"px");
    }
  }, [size,tags]);
  
  return (
    <>
      <div className="formTagsPreview-container">
      {!image && <img className="formTagsPreview-extended-image" style={{"maxWidth":width,"maxHeight":height}} src={XtadiumExtendedInfo}  alt="Your Image" />}
      {image && <img className="formTagsPreview-extended-image" style={{"maxWidth":width,"maxHeight":height}} src={image}  alt="Your Image" />}
        <div className="formTagsPreview-tags">
          <div className="formTagsPreview-top-row"><div>{topTags}</div></div>
          <div className="formTagsPreview-medium-description">{(name?name:"Content name")}</div>
          <div className="formTagsPreview-medium-row"><div style={{ display: 'flex', alignItems: 'center',}}>{mediumTags}</div></div>
          <div className="formTagsPreview-button">SOME TEXT</div>
          <div className="formTagsPreview-bottom-row formTagsPreview-bottom-row--extendedInfo">{bottomTags}</div>
        </div>
      </div>
    </>
  );
};

ExtendedInfoPreview.propTypes = {
  size: PropTypes.string,
};

ExtendedInfoPreview.defaultProps = {
  size: 'xxl',
};

export default ExtendedInfoPreview;
